import Model from './Model'

export default class Order extends Model {
    // Set the resource route of the model
    resource() {
        return 'order'
    }
}
